import React, { FC } from 'react';
import DocumentsNav from 'src/common/DocumentsLibrary/DocumentsNav';
import DocumentsView from 'src/common/DocumentsLibrary/DocumentsView';
import DocumentsDragLayer from 'src/common/DocumentsLibrary/DocumentsDnd/DragLayer';
import { DocumentsUpload, DocumentsCreateFolder } from 'src/common/DocumentsLibrary/DocumentsActions';
import { DocumentsColumnsName } from 'src/common/DocumentsLibrary/types';
import styles from './index.module.scss';
import { IFileNode } from 'src/models/documentsLibrary/types';
import { DocumentLibraryProvider } from './providers';

interface IProps {
  hideFields?: readonly DocumentsColumnsName[];
  files: IFileNode[];
  onAttach?: (fileId: string) => void;
  isAttachLoading?: boolean;
}

export const DocumentsLibrary: FC<IProps> = props => {
  const { hideFields, files, onAttach, isAttachLoading } = props;

  return (
    <DocumentLibraryProvider>
      <DocumentsDragLayer />
      <div className={styles.docs}>
        <div className={styles.docsHeading}>
          <DocumentsNav />
          <ul className={styles.docsActions}>
            <li className={styles.docsActionButton}>
              <DocumentsUpload />
            </li>
            <li className={styles.docsActionButton}>
              <DocumentsCreateFolder />
            </li>
          </ul>
        </div>
        <DocumentsView hideFields={hideFields} files={files} onAttach={onAttach} isAttachLoading={isAttachLoading} />
      </div>
    </DocumentLibraryProvider>
  );
};

export default DocumentsLibrary;
